export default __webpack_public_path__ + "static/ready_project-084457a2d26c5f29619cb2ad1e5a138f.webp";